import { useQuery, useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { buildAxiosInstance } from '../axiosInstance';
import { LogoutCheck } from '../utils';
import { toast } from 'react-toastify';
import { useMsal } from '@azure/msal-react';


export const useInvoiceParentFiltersDashboard = () => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		queryKey: ['invoice_search_parent_filters'],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'dashboard'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					signal:signal
				};
				const responseData = await axiosInstance.get('/invoice_search_parent_filters',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)	
				
			};
		},
	});
};


export const useFetchSecondDashboardData = () => {

	const dispatch = useDispatch();
	const { instance } = useMsal();
	return useMutation({
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'dashboard_second'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				// const responseData = dummyRes.dashboard
				const responseData = await axiosInstance.get(`dashboard_second?category=${body.category}&client=${body.client}&vendor=${body.vendor}&datefrom=${body.datefrom}&dateto=${body.dateto}`);
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw new Error(`${error.response.data.message}`);
				
			}
		},
	});
	 
};